import type { UserRule } from '../shared/contracts';

export interface RuleInput {
  sender: string;
  email: string;
  domain: string;
  subject: string;
  body: string;
}

export type RuleDecision = 'exclude' | 'priority' | 'always' | 'none';

const TRAILING_DATE_PATTERNS = [
  /\s*(?:20\d{2}[./-])?\d{1,2}[./-]\d{1,2}\s*(?:[（(][月火水木金土日](?:曜)?[）)])?\s*$/u,
  /\s*(?:20\d{2}年)?\d{1,2}月\d{1,2}日\s*(?:[（(][月火水木金土日](?:曜)?[）)])?\s*$/u,
];

/** 日付だけが変わる定期メールを識別する。短すぎる件名は広く一致させない。 */
export function deriveSubjectExclusionPattern(subject: string): string {
  const original = subject.trim().replace(/\s+/gu, ' ');
  let pattern = original.replace(/^(?:(?:re|fw|fwd)\s*[:：]\s*)+/iu, '');
  for (const datePattern of TRAILING_DATE_PATTERNS) pattern = pattern.replace(datePattern, '').trim();
  pattern = pattern.replace(/[\s\-ー:：/／]+$/gu, '').trim();
  return [...pattern].length >= 4 ? pattern : original;
}

export function extractSenderEmail(sender: string): string {
  return (sender.match(/<([^>]+)>/)?.[1] ?? sender).trim().toLowerCase();
}

export function applyRules(rules: UserRule[], input: RuleInput): RuleDecision {
  const matches = rules.filter((rule) => input[rule.field].toLocaleLowerCase('ja').includes(rule.pattern.toLocaleLowerCase('ja')));
  if (matches.some((rule) => rule.kind === 'always')) return 'always';
  if (matches.some((rule) => rule.kind === 'priority')) return 'priority';
  if (matches.some((rule) => rule.kind === 'exclude')) return 'exclude';
  return 'none';
}

export function looksLikeAdvertisement(subject: string, body: string): boolean {
  const combined = `${subject}\n${body}`;
  const adSignals = [/[0-9０-９]+%\s*(?:OFF|オフ)/i, /セール|SALE|キャンペーン|クーポン|ポイント倍/i, /配信停止|メルマガ/i];
  return adSignals.filter((pattern) => pattern.test(combined)).length >= 2;
}
